export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';
export const REQUEST_ADMIN_HOST = 'REQUEST_ADMIN_HOST';
export const REQUEST_MARKETING_PATH = 'REQUEST_MARKETING_PATH';
export const REDIRECT_TO_INNER_PATH = 'REDIRECT_TO_INNER_PATH';
